import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

export function useReportModalParam(paramName: string) {
  const [searchParams, setSearchParams] = useSearchParams();
  const reportId = searchParams.get(paramName);

  const open = useCallback(
    (id: string) => {
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);
        next.set(paramName, id);
        return next;
      });
    },
    [paramName, setSearchParams]
  );

  const close = useCallback(() => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.delete(paramName);
      return next;
    });
  }, [paramName, setSearchParams]);

  return { reportId, isOpen: reportId !== null, open, close };
}
